export const OperatorRoleType = {
  ADMIN: 'ADMIN',
  SECURITY_ADMIN: 'SECURITY_ADMIN',
  DEVICE: 'DEVICE',
  ROUTER: 'ROUTER',
  MONITOR: 'MONITOR'
};

export const SyslogTypes = {
  TOPOLOGY: 'TOPOLOGY',
  ROUTER: 'ROUTER',
  CDR: 'CDR'
};

export const prefixSearchTypes = {
  VALUE: 'VALUE',
  MATCH: 'MATCH'
};
